
import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TablePagination, TableBody } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { useSelector, useDispatch } from "react-redux"
import { obtenerFacturasAceptadasPaginaAction, obtenerFacturasAceptadasRegistrosAction } from "../../../ducks/facturacionAceptadasDuck"
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import ButtonDowloadCompSituacionFiscal from "./ButtonDowloadCompSituacionFiscal"
import ButtonAprovarFactura from "./ButtonAprovarFactura"
import ButtonDeclinarFactura from "./ButtonDeclinarFactura"
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import { formatDinero } from "../../../utils/formatDinero"

const columns = [
    { id: "1", minWidth: 50, align: "center", label: "Referencia" },
    { id: "2", minWidth: 50, align: "center", label: "Nombre" },
    { id: "3", minWidth: 50, align: "center", label: "Monto" },
    { id: "4", minWidth: 50, align: "center", label: "Estatus" },
    { id: "5", minWidth: 50, align: "center", label: "Razón social" },
    { id: "6", minWidth: 50, align: "center", label: "Regimen fiscal" },
    { id: "7", minWidth: 50, align: "center", label: "C.P." },
    { id: "8", minWidth: 50, align: "center", label: "RFC" },
    { id: "9", minWidth: 50, align: "center", label: "Fisica" },
    { id: "10", minWidth: 50, align: "center", label: "Moral" },
    { id: "11", minWidth: 50, align: "center", label: "Estatus" },
    { id: "12", minWidth: 50, align: "center", label: "Documento" },
    { id: "13", minWidth: 50, align: "center", label: "" },
]

const useStyles = makeStyles({
    containerRoot: {
        marginTop: "25px",
        marginBottom: "25px"
    },
    containerRootButton: {
        marginTop: "25px",
        marginBottom: "25px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    root: {
        width: '100%',
        padding: '0'
    },
    container: {
        maxHeight: 440,
    },
})

const TFacturas = () => {
    const { listFacturasAceptadas, total, pagina, registros } = useSelector(store => store.facturasAceptadas)
    const rows = listFacturasAceptadas ?? []
    const classes = useStyles()
    const dispatch = useDispatch()
    const handleChangePage = (event, newPage) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerFacturasAceptadasPaginaAction({ Pagina: newPage })).then(Response => {
            dispatch(offLoadAction())
        })
    }
    const handleChangeRowsPerPage = (event) => {
        dispatch(onLoadAnction({ message: "" }))
        dispatch(obtenerFacturasAceptadasRegistrosAction({ Registros: +event.target.value })).then(Response => {
            dispatch(offLoadAction())
        })
    }

    return (
        <div className={classes.containerRoot}>
            <Paper className={classes.root}>
                <TableContainer className={classes.container}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => {
                                return (
                                    <TableRow hover role="checkbox" tabIndex={-1} key={row?.IdFactura}>
                                        <TableCell align='center'>
                                            <ButtonClienteDetalle referencia={row?.Referencia} />
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.Nombre} ${row?.Apellidos}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${formatDinero(row?.Meta?.Paquete?.Cotizacion?.Suma)} ${row?.Meta?.Paquete?.Cotizacion?.Moneda?.Clave}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {`${row?.Meta?.Paquete?.EstatusProceso?.Descripcion}`}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.RazonSolcial}
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatRegimenFiscal?.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.CodigoPostal}`}
                                        </TableCell>
                                        <TableCell align="center">
                                            {`${row?.RFC}`}
                                        </TableCell>
                                        <TableCell align='czenter'>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                {row?.EsFisica && <CheckCircleIcon color='secondary' />}
                                            </div>
                                        </TableCell>
                                        <TableCell align='center'>
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                {row?.EsMoral && <CheckCircleIcon color='secondary' />}
                                            </div>
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row?.CatEstatusFactura?.Descripcion}
                                        </TableCell>
                                        <TableCell align="center">
                                            <ButtonDowloadCompSituacionFiscal
                                                IdFactura={row?.IdFactura}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "1rem" }}>
                                                <ButtonAprovarFactura
                                                    IdFactura={row?.IdFactura}
                                                />
                                                <ButtonDeclinarFactura
                                                    IdFactura={row?.IdFactura}
                                                />
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={total}
                    rowsPerPage={registros}
                    page={pagina}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    )
}
export default TFacturas